import React from 'react';
import { useSelector } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Switch } from 'react-router';
import { useHistory } from 'react-router-dom';
import { AuthSession, usePortalCmsLogout, useAuthSession } from '@spins/react-sso-provider';

import Footer from 'components/Footer';
import MainHeader from 'components/MainHeader';
import MainNavigation, { NavigationLink } from 'components/MainNavigation';
import { hamburgerMenuItemsSelector } from 'containers/AccessControl/selectors';
import ErrorBoundary from 'containers/ErrorBoundary';
import CommonRoutes from 'containers/Main/CommonRoutes';

import { currentBrandSelector, isEnterpriseContextSelector } from 'store/global/selectors';

import { OTHER_ROUTES } from 'utils/routes';
import '../styles.scss';
import SupportButton from "../../../components/SupportButton";

interface Props {
  navigationLinks: Array<NavigationLink>;
}

const BrandMain: React.FC<Props> = ({ navigationLinks }) => {
  const currentBrand: string = useSelector(currentBrandSelector);
  const hamburgerMenuItems = useSelector(hamburgerMenuItemsSelector);
  const isEnterpriseContext = useSelector(isEnterpriseContextSelector);
  const history = useHistory();
  const authSession: AuthSession = useAuthSession();
  const { logout } = usePortalCmsLogout();

  return (
    <>
      <div className="main-container">
        <Container fluid>
          <Row>
            <MainHeader
              changeBrandLabel={isEnterpriseContext ? 'Switch Company' : 'Switch Brand'}
              currentBrandName={currentBrand}
              items={hamburgerMenuItems}
              userInfo={authSession.user}
              onChangeBrand={() => history.push(OTHER_ROUTES.CHANGE_BRAND)}
              onLogout={() => logout(OTHER_ROUTES.LOGOUT)}
            />
          </Row>
          <Row>
            <MainNavigation links={navigationLinks} />
          </Row>
          <ErrorBoundary>
            <Switch>
              <CommonRoutes />
            </Switch>
          </ErrorBoundary>
        </Container>
      </div>
      <Footer />
      <SupportButton />
    </>
  );
};

export default BrandMain;
